import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { getUserInfo } from "../endpoints/user";
import { useBackendCurrency } from "../lang-context";
import { queryKeys } from "../query-keys";

export function useUserInfo(authToken: string | null) {
  const currency = useBackendCurrency();
  return useQuery({
    queryKey: [...queryKeys.userInfo(), currency],
    queryFn: () => getUserInfo({ baseUrl: API_BASE_URL }, authToken as string, { currency }),
    enabled: !!authToken,
    // P1-E: profile/balance change rarely within a session; 5min staleTime
    // keeps the header/account avatar cached on tab-return instead of
    // re-fetching (and flashing) every 60s.
    staleTime: 5 * 60 * 1000,
  });
}
